




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import firebase from "firebase";

@Component
export default class TripImage extends Vue {
  imageUrl: String = "img/thailand.jpg";

  @Prop()
  readonly placeId!: string;

  async created() {
    try {
      this.imageUrl = await firebase
        .storage()
        .ref("places_photos/" + this.placeId)
        .getDownloadURL();
    } catch (error) {
      console.log(error);
    }
  }
}
